import styled from "styled-components";
import { FontFamily } from "../../../global-files/variables";

export const ContainerModal = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  display: grid;
  place-items: center;
  background-color: rgba(0, 0, 0, 0.4);

  .contentModal {
    width: fit-content;
    max-width: 80%;
    min-width: 80px;
    height: fit-content;
    max-height: 90%;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    padding: 25px 25px 20px 25px;
    box-shadow: 0px 2px 4px 0px #00000040;

    header {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 6px;

      .label-title {
        width: 100%;
        text-align: center;
        font-family: ${FontFamily.RobotoMedium}, sans-serif;
        font-size: 17px;
        line-height: 1.2;
        color: #262626;
        white-space: pre-wrap;
      }

      & + * {
        margin-top: 20px;
      }
    }

    .iconModal {
      width: 50px;
      height: 50px;
      font-size: 30px;
      border-width: 4px;
      margin-bottom: 20px;
      overflow: hidden;

      &.iconModal-error {
        background-color: #953737;
        border-color: #953737;
        color: white;
      }
      &.iconModal-warning {
        font-size: 27px;
        padding-bottom: 8px;
        color: #af9647;
        border-color: #af9647;
      }
      &.iconModal-info {
        border-color: #9e3e26;
        color: #9e3e26;
      }
      &.iconModal-success {
      }
      &.iconModal-successv2{
        border-color: #85BC5B;
        color: #85BC5B;
      }
    }

    .label-message {
      width: 100%;
      text-align: center;
      font-family: ${FontFamily.RobotoRegular}, sans-serif;
      font-size: 13px;
      color: #707070;
      white-space: pre-wrap;
    }

    .container-customComponent {
      width: 100%;
      max-height: 50vh;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      padding: 0px 0px;
      //border: 1px solid red;
    }

    .container-buttons {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 12px;
      margin-top: 20px;
      //border: 1px solid red;
    }
  }
`;
